// components/forms/PhysicalExamForm.js
import React from 'react';

function PhysicalExamForm({ data, setData }) {
    const handleChange = (field, value) => {
        setData({
            ...data,
            [field]: value
        });
    };

    const handleMuscleStrengthChange = (field, value) => {
        setData({
            ...data,
            muscleStrength: {
                ...data.muscleStrength,
                [field]: value
            }
        });
    };

    return (
        <div className="space-y-4">
            <h2 className="text-xl font-bold mb-4">体格检查</h2>

            <div className="grid grid-cols-1 gap-4">
                <h3 className="text-md font-semibold text-gray-700 mb-2">生命体征</h3>
                <div className="grid grid-cols-2 md:grid-cols-5 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">体温 (℃)</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={data.temperature}
                            onChange={(e) => handleChange('temperature', e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">心率 (次/分)</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={data.heartRate}
                            onChange={(e) => handleChange('heartRate', e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">呼吸 (次/分)</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={data.respiratoryRate}
                            onChange={(e) => handleChange('respiratoryRate', e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">血压 (mmHg)</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={data.bloodPressure}
                            onChange={(e) => handleChange('bloodPressure', e.target.value)}
                        />
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">血氧饱和度 (%)</label>
                        <input
                            type="text"
                            className="w-full p-2 border rounded"
                            value={data.oxygenSaturation}
                            onChange={(e) => handleChange('oxygenSaturation', e.target.value)}
                        />
                    </div>
                </div>

                <h3 className="text-md font-semibold text-gray-700 mt-4 mb-2">神经系统检查</h3>
                <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">神志</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.consciousness}
                            onChange={(e) => handleChange('consciousness', e.target.value)}
                        >
                            <option value="清醒">清醒</option>
                            <option value="嗜睡">嗜睡</option>
                            <option value="昏迷">昏迷</option>
                            <option value="意识模糊">意识模糊</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">言语</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.speech}
                            onChange={(e) => handleChange('speech', e.target.value)}
                        >
                            <option value="">请选择</option>
                            <option value="正常">正常</option>
                            <option value="言语含糊不清（构音障碍）">言语含糊不清（构音障碍）</option>
                            <option value="运动性失语">运动性失语</option>
                            <option value="感觉性失语">感觉性失语</option>
                            <option value="混合性失语">混合性失语</option>
                        </select>
                    </div>
                </div>

                <h3 className="text-md font-semibold text-gray-700 mt-4 mb-2">肌力</h3>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">右上肢</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.muscleStrength.rightUpper}
                            onChange={(e) => handleMuscleStrengthChange('rightUpper', e.target.value)}
                        >
                            <option value="0">0级</option>
                            <option value="1">1级</option>
                            <option value="2">2级</option>
                            <option value="3">3级</option>
                            <option value="4">4级</option>
                            <option value="5">5级</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">右下肢</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.muscleStrength.rightLower}
                            onChange={(e) => handleMuscleStrengthChange('rightLower', e.target.value)}
                        >
                            <option value="0">0级</option>
                            <option value="1">1级</option>
                            <option value="2">2级</option>
                            <option value="3">3级</option>
                            <option value="4">4级</option>
                            <option value="5">5级</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">左上肢</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.muscleStrength.leftUpper}
                            onChange={(e) => handleMuscleStrengthChange('leftUpper', e.target.value)}
                        >
                            <option value="0">0级</option>
                            <option value="1">1级</option>
                            <option value="2">2级</option>
                            <option value="3">3级</option>
                            <option value="4">4级</option>
                            <option value="5">5级</option>
                        </select>
                    </div>

                    <div>
                        <label className="block text-sm font-medium text-gray-700 mb-1">左下肢</label>
                        <select
                            className="w-full p-2 border rounded"
                            value={data.muscleStrength.leftLower}
                            onChange={(e) => handleMuscleStrengthChange('leftLower', e.target.value)}
                        >
                            <option value="0">0级</option>
                            <option value="1">1级</option>
                            <option value="2">2级</option>
                            <option value="3">3级</option>
                            <option value="4">4级</option>
                            <option value="5">5级</option>
                        </select>
                    </div>
                </div>

                <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">NIHSS评分</label>
                    <input
                        type="text"
                        className="w-full p-2 border rounded"
                        placeholder="例如：9分"
                        value={data.nihssScore}
                        onChange={(e) => handleChange('nihssScore', e.target.value)}
                    />
                </div>
            </div>
        </div>
    );
}

export default PhysicalExamForm;